module.exports = __webpack_public_path__ + "img/phoneaccess.1f65a58f.png";